import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import NewsRepositoriesFactory from '../Repositories/factory.js'

/**
 * @implements UseCase
 */
export class GetLatestPlatesNewsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config - Configuration object
   * @param {Object} deps.httpNewsRepository - Repository to fetch news
   */
  constructor({httpNewsRepository, config}) {
    super()
    this._httpNewsRepository = httpNewsRepository
    this._config = config
  }

  @tracer({metric: 'GetLatestPlatesNewsUseCase#execute'})
  @AsyncInlineError()
  async execute() {
    const [repositoryError, latestPlatesVO] = await this._httpNewsRepository.getLatestPlates()

    if (repositoryError) return Promise.reject(repositoryError)

    return latestPlatesVO.toJSON()
  }

  static create({config}) {
    return new GetLatestPlatesNewsUseCase({
      config,
      httpNewsRepository: NewsRepositoriesFactory.hTTPNewsRepository({config})
    })
  }
}

export const factory = GetLatestPlatesNewsUseCase.create
